
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from "@/components/ui/dialog";
import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import logger from '@/utils/logger';

interface RentalRulesDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function RentalRulesDialog({ isOpen, onClose }: RentalRulesDialogProps) {
  logger.debug('Рендер RentalRulesDialog, isOpen:', isOpen);
  
  const handleViewFullRules = () => {
    window.open('https://tuk-tuk.rent/rental-terms', '_blank');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px] max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Договор оферты</DialogTitle>
          <DialogDescription>
            Основные положения договора оферты
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 text-sm">
          <section>
            <h3 className="font-bold mb-2">1. Общие положения</h3>
            <p>
              Настоящие правила регулируют отношения между Арендодателем (ООО "Тук-Тук") и 
              Арендатором (курьером) по использованию транспортного средства (электровелосипеда).
            </p>
          </section>
          
          <section>
            <h3 className="font-bold mb-2">2. Правила эксплуатации</h3>
            <ul className="space-y-1 list-disc pl-5">
              <li>Использовать велосипед только лично, не передавать третьим лицам</li>
              <li>Соблюдать правила дорожного движения</li>
              <li>Не разбирать, не модифицировать велосипед</li>
              <li>Не использовать велосипед в опасных условиях</li>
              <li>Заряжать аккумулятор только с помощью предоставленного зарядного устройства</li>
            </ul>
          </section>
          
          <section>
            <h3 className="font-bold mb-2">3. Ответственность</h3>
            <ul className="space-y-1 list-disc pl-5">
              <li>За повреждение велосипеда - стоимость ремонта</li>
              <li>За утерю - полная стоимость велосипеда</li>
              <li>За нарушение правил - штрафы согласно договору</li>
            </ul>
          </section>
          
          <div className="border-t pt-4 mt-4 flex justify-between items-center">
            <p className="text-muted-foreground text-xs">
              Ознакомьтесь с полной версией договора на сайте
            </p>
            <Button 
              variant="outline" 
              onClick={handleViewFullRules} 
              className="flex items-center gap-1"
            >
              <span>Полная версия</span>
              <ExternalLink className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
